var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tiles"},_vm._l((_vm.data.GuiNodeCh),function(child){return _c('Tile',{key:child.Xnodekey,attrs:{"data":child}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }